import { Variant } from "@~/types/types";
import styles from "../EnergyRating.module.scss";
import { OpenInNewOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/OpenInNewOutlined";

type Props = {
  energy: NonNullable<Variant["energy"]>;
};

export function InformationSheet({ energy }: Props) {
  if (!energy.informationSheet) {
    return null;
  }

  return (
    <span className={styles.energyInformationSheetSection}>
      <a
        href={energy.informationSheet}
        className={styles.energyInformationSheetLink}
        data-testid="engInfosheetLink"
        target="_blank"
        rel="noopener noreferrer"
      >
        Product Information Sheet
      </a>
      <OpenInNewOutlined title="Open in new tab" size="medium" />
    </span>
  );
}
